import { STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { PAGE_TYPES } from '@src/constants/page-type'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { SlugInfo } from '@src/server-side/api/fetch-slug-info'
import { FEATURE_FLAG_TYPE } from '@src/server-side/server-feature-flags/feature-flag.types'

export enum PageType {
  HOME = 'HOME',
  COLLECTION = 'COLLECTION',
  SUBCOLLECTION = 'SUBCOLLECTION',
  REDIRECT = 'REDIRECT',
  PRODUCT = 'PRODUCT',
  UNKNOWN = 'UNKNOWN',
}

export const SERVER_SIDE_RENDER_TIME_HEADER = 'X-Server-Side-Render-Time'
export const CATCH_ALL_IGNORE_PREFIXES = ['_next', 'static-assets', 'api', 'ecomm-ssr']
export type ServerSideProps =
  | ({ type: '_page' } & ServerSideBaseProps)
  | {
      type: '_ignore_path'
    }

export function getPageType(slugInfoType?: string | null): PageType {
  switch (slugInfoType) {
    case 'homePage':
      return PageType.HOME
    case 'product':
      return PageType.PRODUCT
    case 'collection':
      return PageType.COLLECTION
    case 'subcollection':
      return PageType.SUBCOLLECTION
    case 'redirection':
      return PageType.REDIRECT
    default:
      return PageType.UNKNOWN
  }
}

export function isCollectionPage(pageType: PageType): boolean {
  return pageType === PageType.COLLECTION || pageType === PageType.SUBCOLLECTION
}

export function isProductPage(pageType: PageType): boolean {
  return pageType === PageType.PRODUCT
}

export function getPageTypeFromSlugInfo(slugInfo: SlugInfo | null): PageType {
  return getPageType(slugInfo?.type)
}

export function isBundleProduct(props: ServerSideBaseProps): boolean {
  const pageDataJson = props.pageData?.context?.pageDataJson
  return Boolean(pageDataJson && typeof pageDataJson === 'object' && 'bundle' in pageDataJson)
}

export function shouldShowMiniPDP(props: ServerSideBaseProps): boolean {
  if (props.pageData?.context?.ssrPageType === PAGE_TYPES.PRODUCT_AND_BUNDLE) {
    const productFeatureFlags =
      props.serverSideFeatureFlags?.featureFlagType === FEATURE_FLAG_TYPE.PRODUCT ? props.serverSideFeatureFlags : null
    return productFeatureFlags?.miniPDPExperimentBucket === STATSIG_EXPERIMENTS_BUCKETS.SHOW && !isBundleProduct(props)
  }

  return false
}
